import TeamsUriHelper from "@/helpers/utilities/TeamsUriHelper";

/**
 * Skobo Tile class a tile in the dashboard grid
 * @category Models
 * @subcategory Tiles
 * @class Tile
 * @name Tile
 */

class Tile {
  id = "";
  title = "";
  description = "";
  uri = {
    action: "",
    uri: ""
  };
  sort = 0;
  icon = "";
  backgroundColor = "";
  groupName = "";
  iconFramed = false;
  iconImage = false;

  constructor() {}

  // Getters

  //
  //
  // Methods

  //
  //
  // Static Methods
  /**
   * Parse tile object from API to NCT Tile
   * @param {object} data Object from api
   * @returns {object} NCT tile
   */
  static parseFromApi(data) {
    const tile = Object.assign(new Tile(), data);

    if (tile.uri && tile.uri.uri && tile.uri.uri.indexOf("teams.microsoft.com") > -1) {
      tile.uri.uri = TeamsUriHelper.generateTeamViewUri(tile.uri.uri);
    }

    if (tile.title.indexOf("{") == -1 && tile.title.indexOf("}") == -1) {
      breakingWords.forEach(element => {
        if (tile.title.match(element) != null) {
          tile.title = tile.title.replace(element, "<wbr/>" + element + "<wbr/>");
        }
      });
    }

    const uriSplit = tile.icon?.split("|");

    if (uriSplit?.length > 1) {
      tile.icon = uriSplit[1];

      if (uriSplit[0] === "framed") {
        tile.iconFramed = true;
      }

      if (uriSplit[0] === "image") {
        tile.iconImage = true;
      }
    }

    return tile;
  }
}

const breakingWords = [
  "dokumenter",
  "documents",
  "klasse",
  "class",
  "fælles",
  "common",
  "lukkede",
  "closed",
  "kontor",
  "website"
];

export default Tile;
